import { render, staticRenderFns } from "./AppBottomScreen.vue?vue&type=template&id=a56b6de2&scoped=true"
import script from "./AppBottomScreen.vue?vue&type=script&lang=js"
export * from "./AppBottomScreen.vue?vue&type=script&lang=js"
import style0 from "./AppBottomScreen.vue?vue&type=style&index=0&id=a56b6de2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56b6de2",
  null
  
)

export default component.exports